export const CPS_CONFIRM_DIALOG_STATE = {
  YES: 'yes',
  NO: 'no',
  DISMISS: 'dismiss'
} as const;

export type CpsConfirmDialogState = (typeof CPS_CONFIRM_DIALOG_STATE)[keyof typeof CPS_CONFIRM_DIALOG_STATE];
